// constants
import { commonImage } from 'constants/images';

// libraries
import styled from 'styled-components';

export const StyledChangePasswordModal = styled.div`
  .cpm-wrapper {
    text-align: left;

    &-header {
      display: flex;
      justify-content: space-between;
      padding: 20px 28px;
      border-bottom: 1px solid var(--color-border-light-gray);

      h1 {
        font-size: 18px;
        font-weight: 600;
        line-height: 27px;
      }

      &-close {
        width: 24px;
        height: 24px;
        background-image: url(${commonImage.modalClose});
        background-size: cover;
        cursor: pointer;
      }
    }

    &-body {
      padding: 20px 28px 10px;

      p {
        font-size: 14px;
        font-weight: 400;
        line-height: 21px;
        text-align: left;
        margin-bottom: 18px;
      }

      &-content {
        margin-bottom: 16px;

        &.double {
          > div {
            height: auto;

            &:first-child {
              margin-bottom: 17px;
            }

            .nation-select {
              height: 40px;

              .MuiInputBase-root {
                padding: 0 !important;
                padding-left: 8px !important;
                padding-right: 26px !important;

                > .MuiInputBase-input {
                  padding-left: 0 !important;
                }
              }
            }
          }
        }

        .checking-password {
          font-size: 14px;
          font-weight: 400;
          padding-left: 18px;
          position: relative;
          color: var(--color-warning);
          margin-bottom: 6px;
          line-height: 1.2;

          &.true {
            color: var(--color-success);

            &::before {
              background: var(--color-success);
            }
          }

          &::before {
            content: '';
            position: absolute;
            left: 0px;
            top: 48%;
            transform: translateY(-50%);
            width: 12px;
            height: 12px;
            border-radius: 50%;
            background: var(--color-warning);
          }
        }
      }
    }

    &-footer {
      display: flex;
      flex-direction: row-reverse;
      gap: 8px;
      padding: 0 28px;

      .MuiButtonBase-root {
        background: var(--color-primary-blue);
        width: 90px;
        height: 37px;
        text-transform: none;
      }
    }
  }
`;
